import * as Yup from 'yup'
import {useState, useEffect} from 'react'
import axios from 'axios'
import {Link} from 'react-router-dom'
import {useParams} from 'react-router-dom'
import {useUser} from '../../../../modules/newauth/UserContext'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import Select from 'react-select'
import DataTable from 'react-data-table-component'
import {getParameterType} from '../../../../functions/VBox/GetParameterType'
import * as XLSX from 'xlsx'
import firebase from '../../../../firebase/FirebaseConfig'
import apiConnect from '../../../../api/apiConnect'

const VBoxCreateNewParameter = () => {
  const deviceId = useParams().deviceId
  const {user} = useUser()
  const navigate = useNavigate()
  const db = firebase.firestore()

  const [excelData, setExcelData] = useState([])
  const [fileData, setFileData] = useState(null)
  const [selectedParameter, setSelectedParameter] = useState(null)
  const [listParameter, setListParameter] = useState([])

  const [parameterUnit, setParameterUnit] = useState('') // State สำหรับเก็บ parameterUnit
  const [parameterName, setParameterName] = useState('') // State สำหรับเก็บ parameterUnit
  const [parameterOwner, setParameterOwner] = useState('') // State สำหรับเก็บ parameterUnit
  const [selectedUnit, setSelectedUnit] = useState(null)
  const [unitLists, setUnitLists] = useState([])
  const [iconUrl, setIconUrl] = useState('') // State สำหรับจัดการ icon URL
  const [deviceData, setDeviceData] = useState([])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/devices/by-device-id/${deviceId}`)

        // Check Device ID
        if (response?.data?.status == 'error' && response?.data?.text == 'No such document!') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Device not found!',
          }).then(() => {
            navigate(`/device/${deviceId}`)
          })
        }

        // Check Device Limit
        if (response?.data?.limitParameter) {
          const countAllParameter =
            response?.data?.digital_output?.length +
            response?.data?.sensor?.length +
            response?.data?.setting_parameter?.length +
            response?.data?.status_parameter?.length
          // console.log(countAllParameter)
          // console.log(response?.data?.limitParameter)

          if (countAllParameter >= response?.data?.limitParameter) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'You have reached the maximum number of parameters for this device.',
            }).then(() => {
              navigate(`/device/${deviceId}`)
            })
          }
        }

        // Check Device Owner
        if (user?.role == 'user') {
          if (response?.data?.owner !== user?.userIdMalin1) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'You are not the owner of this device.',
            }).then(() => {
              navigate(`/device/${deviceId}`)
            })
          }
        }

        setDeviceData(response.data)
        setParameterOwner(response.data.owner)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [selectedParameter])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/units/all-unit/`)

        const sortedUnits = response.data.sort((a, b) => {
          if (a.quantity_name < b.quantity_name) return -1
          if (a.quantity_name > b.quantity_name) return 1
          return 0
        })

        setUnitLists(sortedUnits)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [selectedParameter])

  useEffect(() => {
    const fetchData = async () => {
      let listParameter = []
      await db
        .collection('parameters')
        .where('deviceId', '==', deviceId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listParameter.push(doc.data().parameterAddress)
          })
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })

      await db
        .collection('statusParameters')
        .where('deviceId', '==', deviceId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listParameter.push(doc.data().parameterAddress)
          })
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })

      await db
        .collection('settingParameters')
        .where('deviceId', '==', deviceId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listParameter.push(doc.data().parameterAddress)
          })
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })

      setListParameter(listParameter)
    }
    fetchData()
  }, [selectedParameter])

  useEffect(() => {
    const selectedUnit = unitLists.find((unit) => unit.unit_id === parameterUnit)
    if (selectedUnit) {
      if (deviceData.premium) {
        setIconUrl(selectedUnit.premium_parameter_icon) // อัปเดต URL รูปจาก unitLists
        setSelectedUnit(selectedUnit) // อัปเดตค่า selectedUnit
      } else {
        setIconUrl(selectedUnit.parameter_icon) // อัปเดต URL รูปจาก unitLists
        setSelectedUnit(selectedUnit) // อัปเดตค่า selectedUnit
      }
    } else {
      setIconUrl('') // ตั้งค่าเริ่มต้นหากไม่มีการเลือก
      setSelectedUnit(null) // ตั้งค่าเริ่มต้นหากไม่มีการเลือก
    }
  }, [parameterUnit, unitLists]) // เพิ่ม parameterUnit เป็น dependency

  const handleParameterUnitChange = (e) => {
    setParameterUnit(e.target.value) // อัปเดตค่า parameterUnit เมื่อเลือก
  }

  const columns = [
    {
      name: 'Action',
      selector: (row) => row.Name,
      sortable: true,
      cell: (row) => {
        return (
          <>
            {listParameter.includes(`@${row.Name}`) ? (
              <p className='text-danger fw-bold mt-4 ms-3'>Already Exist</p>
            ) : (
              <div
                className='btn btn-sm btn-primary w-auto'
                style={{fontSize: '12px', padding: '5px 7px'}}
                onClick={() => handleSelectParameter(row)}
              >
                <i className='fas fa-plus fs-6 ms-2 me-1'></i>
                Create parameter
              </div>
            )}
          </>
        )
      },
    },
    {
      name: 'Name',
      selector: (row) => row.Name,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p className='fw-semibold'>{row.Name}</p>
          </>
        )
      },
    },
    {
      name: 'GroupName',
      selector: (row) => row.GroupName,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p>{row.GroupName}</p>
          </>
        )
      },
    },
    {
      name: 'DataType',
      selector: (row) => row.DataType,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p>{row.DataType}</p>
          </>
        )
      },
    },
    {
      name: 'FloatPoint',
      selector: (row) => row.FloatPoint,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p>{row.FloatPoint}</p>
          </>
        )
      },
    },
  ]

  const handleFileUpload = (e) => {
    const file = e.target.files[0]
    if (!file) return

    setFileData(file)

    const reader = new FileReader()

    reader.onload = (evt) => {
      const data = evt.target.result
      const workbook = XLSX.read(data, {type: 'binary'})

      const sheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[sheetName]
      const json = XLSX.utils.sheet_to_json(worksheet)
      console.log(json)

      setExcelData(json)
    }

    reader.readAsBinaryString(file)

    // ✅ รีเซ็ต input file เพื่อให้สามารถเลือกไฟล์เดิมได้อีกรอบ
    e.target.value = null
  }

  const handleSelectParameter = async (row) => {
    const PAR_TYPE = getParameterType(row)
    if (PAR_TYPE == 'not-found') {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Parameter Type not found!',
      })
      return
    }

    setSelectedParameter({
      ...row,
      collectionType: 'C.LT',
      operationType: 'O.N',
      PAR_TYPE: PAR_TYPE,
      operationValue: 0,
    })
  }

  const handleBack = () => {
    setSelectedParameter(null)
    setSelectedParameter(null)
    setParameterUnit('')
    setParameterName('')
    setParameterOwner('')
    setSelectedUnit(null)
    setIconUrl('')
    setDeviceData([])
    setUnitLists([])
  }

  const handleCreateParameter = async () => {
    if (selectedParameter?.parameterType === 'parameter') {
      const payload = {
        gatewayId: deviceData.gateway_id,
        iconUrl: deviceData.premium
          ? selectedUnit.premium_parameter_icon
          : selectedUnit.parameter_icon,
        name: parameterName,
        ownerId: parameterOwner,
        unitFormat: selectedUnit.unit_symbol,
        unitId: selectedUnit.unit_id,
        deviceId: deviceId,
        premium: deviceData.premium,
      }

      Swal.fire({
        title: 'Creating new parameter...',
        html: 'Please wait a moment.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        const response = await apiConnect.post('/v1/parameters/create-new-parameter', payload)

        await db
          .collection('parameters')
          .doc(response.data.data.parameterId)
          .set({
            parameterName: parameterName,
            parameterAddress: `@${selectedParameter.Name}`,
            dataType: selectedParameter.DataType,
            parameterType: selectedParameter.PAR_TYPE,
            operationType: selectedParameter.operationType,
            collectionType: selectedParameter.collectionType,
            operationValue: selectedParameter.operationValue,
            deviceId: deviceId,
            createdBy: 'vbox-import-xlsx',
            ownerId: parameterOwner,
          })
          .then(() => {
            console.log('Document successfully written!')
            Swal.fire({
              icon: 'success',
              title: 'Create new parameter successfully!',
              html: `<div>
                      <p>Parameter Name : ${response.data.data.name}</p>
                      <p>Parameter ID : ${response.data.data.parameterId}</p>
                   </div>`,
            })
              .then(async () => {
                // navigate(`/device/${deviceId}`)
                setSelectedParameter(null)
                setParameterUnit('')
                setParameterName('')
                setParameterOwner('')
              })
              .catch((error) => {
                console.error('Error writing document: ', error)
              })
          })
      } catch (error) {
        console.error('Error fetching data:', error)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        })
      }
    } else if (selectedParameter?.parameterType === 'setting_parameter') {
      const payload = {
        gatewayId: deviceData.gateway_id,
        iconUrl: deviceData.premium
          ? 'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/Setting_parameter%2Fsetting_parameter_premium.png?alt=media&token=2617106e-4985-4347-96e5-523d62c50bad'
          : 'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/Setting_parameter%2Fsetting_parameter.png?alt=media&token=7e3655c7-3ef6-4287-8610-8fbf133d41ee',
        name: parameterName,
        ownerId: parameterOwner,
        unitFormat: selectedUnit.unit_symbol,
        unitId: selectedUnit.unit_id,
        deviceId: deviceId,
        premium: deviceData.premium,
      }

      Swal.fire({
        title: 'Creating new parameter...',
        html: 'Please wait a moment.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        const response = await apiConnect.post(
          '/v1/setting-parameters/create-new-setting-parameter',
          payload
        )

        await db
          .collection('settingParameters')
          .doc(response.data.data.parameterId)
          .set({
            parameterName: parameterName,
            parameterAddress: `@${selectedParameter.Name}`,
            dataType: selectedParameter.DataType,
            parameterType: selectedParameter.PAR_TYPE,
            deviceId: deviceId,
            createdBy: 'vbox-import-xlsx',
            ownerId: parameterOwner,
          })
          .then(() => {
            console.log('Document successfully written!')
            Swal.fire({
              icon: 'success',
              title: 'Create new parameter successfully!',
              html: `<div>
                      <p>Parameter Name : ${response.data.data.name}</p>
                      <p>Parameter ID : ${response.data.data.parameterId}</p>
                   </div>`,
            })
              .then(async () => {
                // navigate(`/device/${deviceId}`)
                setSelectedParameter(null)
                setParameterUnit('')
                setParameterName('')
                setParameterOwner('')
              })
              .catch((error) => {
                console.error('Error writing document: ', error)
              })
          })
      } catch (error) {
        console.error('Error fetching data:', error)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        })
      }
    } else if (selectedParameter?.parameterType === 'status_parameter') {
      const payload = {
        gatewayId: deviceData.gateway_id,
        iconUrl:
          'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/status_parameter%2F258682998-765cb53b-7e26-4a95-a1a0-986381559617.png?alt=media&token=b1f45a54-02d2-4a34-8daa-b37363a02e42',
        name: parameterName,
        ownerId: parameterOwner,
        deviceId: deviceId,
        premium: deviceData.premium,
      }

      Swal.fire({
        title: 'Creating new parameter...',
        html: 'Please wait a moment.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        const response = await apiConnect.post(
          '/v1/status-parameters/create-new-status-parameter',
          payload
        )

        await db
          .collection('statusParameters')
          .doc(response.data.data.parameterId)
          .set({
            parameterName: parameterName,
            parameterAddress: `@${selectedParameter.Name}`,
            dataType: selectedParameter.DataType,
            parameterType: selectedParameter.PAR_TYPE,
            deviceId: deviceId,
            createdBy: 'vbox-import-xlsx',
            ownerId: parameterOwner,
          })
          .then(() => {
            console.log('Document successfully written!')
            Swal.fire({
              icon: 'success',
              title: 'Create new parameter successfully!',
              html: `<div>
                      <p>Parameter Name : ${response.data.data.name}</p>
                      <p>Parameter ID : ${response.data.data.parameterId}</p>
                   </div>`,
            })
              .then(async () => {
                // navigate(`/device/${deviceId}`)
                setSelectedParameter(null)
                setParameterUnit('')
                setParameterName('')
                setParameterOwner('')
              })
              .catch((error) => {
                console.error('Error writing document: ', error)
              })
          })
      } catch (error) {
        console.error('Error fetching data:', error)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        })
      }
    }
  }

  const unitOptions = unitLists.map((unit) => ({
    value: unit.unit_id,
    label: unit.quantity_name + ' (' + unit.unit_symbol + ')',
    icon: deviceData?.premium ? unit.premium_parameter_icon : unit.parameter_icon,
  }))

  // ตัว renderer สำหรับแสดง label + รูป
  const formatOptionLabel = ({label, icon}) => (
    <div className='d-flex align-items-center gap-3'>
      <img src={icon} alt='icon' style={{width: 24, height: 24}} />
      <span>{label}</span>
    </div>
  )

  return (
    <>
      <div className='d-flex flex-wrap flex-stack mb-6'>
        <h3 className='fw-bolder'>Create New Parameter (Vbox)</h3>

        <div className='d-flex my-2'>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3'>
              <Link to={'/dashboard'} className='pe-3'>
                Home
              </Link>
            </li>

            <li className='breadcrumb-item pe-3'>
              <Link to={`/device/${deviceId}`} className='pe-3'>
                {deviceData?.name}
              </Link>
            </li>

            <li className='breadcrumb-item px-3 text-muted'>Create parameter</li>
          </ol>
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Create New Parameter</h3>
          </div>
        </div>

        <div className='collapse show'>
          <div className='card-body border-top p-9'>
            {selectedParameter == null ? (
              excelData.length === 0 ? (
                <>
                  <h5 className='fw-bold mb-3'>
                    กรุณาอัปโหลดไฟล์ .xlsx ที่มีข้อมูล Parameter ตามรูปแบบที่กำหนด
                  </h5>
                  <label className='btn btn-primary'>
                    <i className='fas fa-file-arrow-up fs-4 me-2'></i>Import .xlsx
                    <input type='file' accept='.xlsx, .xls' onChange={handleFileUpload} hidden />
                  </label>
                </>
              ) : (
                <>
                  <div className='d-flex justify-content-between align-items-center mb-3'>
                    <div>
                      <h4 className='mb-1'>รายการ Parameter ในไฟล์</h4>
                      <p className='text-muted mb-0'>
                        <strong>File:</strong> {fileData?.name} | <strong>Size:</strong>
                        {fileData?.size > 1024 * 1024
                          ? `${(fileData.size / (1024 * 1024)).toFixed(2)} MB`
                          : `${(fileData.size / 1024).toFixed(2)} KB`}
                      </p>
                    </div>

                    <button
                      className='btn btn-danger btn-sm'
                      onClick={() => {
                        setExcelData([])
                        setFileData(null)
                      }}
                    >
                      Reset
                    </button>
                  </div>

                  <div className='card'>
                    <DataTable
                      columns={columns}
                      data={excelData}
                      pagination
                      paginationPerPage={20}
                      paginationRowsPerPageOptions={[20, 50, 100]}
                    />
                  </div>
                </>
              )
            ) : (
              <div className=''>
                <div className='btn btn-primary btn-sm' onClick={() => handleBack()}>
                  <i className='fas fa-arrow-left fs-5 me-2'></i>Back
                </div>
                <div className='row'>
                  <div className='col-12 mt-3'>
                    {/* Parameter Address */}
                    <div className='row mb-3'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                        Parameter Address
                      </label>
                      <div className='col-lg-8'>
                        <p className='fs-5 fw-semibold mt-3 text-info'>@{selectedParameter.Name}</p>
                      </div>
                    </div>

                    {/* Parameter Type */}
                    <div className='row mb-3'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                        Parameter Type (V-Box)
                      </label>

                      <div className='col-lg-8'>
                        <p className='fs-5 fw-semibold mt-3 text-info'>
                          @{selectedParameter.PAR_TYPE}
                        </p>
                      </div>
                    </div>

                    <div className='row mb-3'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                        Parameter Type
                      </label>

                      <div className='col-lg-8'>
                        <Select
                          options={[
                            {value: '', label: 'Select parameter type...'},
                            {value: 'parameter', label: 'Parameter'},
                            {value: 'setting_parameter', label: 'Setting Parameter'},
                            {value: 'status_parameter', label: 'Status Parameter'},
                          ]}
                          value={[
                            {value: '', label: 'Select parameter type...'},
                            {value: 'parameter', label: 'Parameter'},
                            {value: 'setting_parameter', label: 'Setting Parameter'},
                            {value: 'status_parameter', label: 'Status Parameter'},
                          ].find((option) => option.value === selectedParameter?.parameterType)}
                          onChange={(selectedOption) => {
                            setSelectedParameter({
                              ...selectedParameter,
                              parameterType: selectedOption?.value || '',
                            })
                          }}
                          classNamePrefix='react-select'
                          isClearable
                        />
                      </div>
                    </div>

                    {selectedParameter?.parameterType === 'parameter' ||
                    selectedParameter?.parameterType === 'setting_parameter' ||
                    selectedParameter?.parameterType === 'status_parameter' ? (
                      <div className='separator border-3 my-7'></div>
                    ) : null}

                    {selectedParameter?.parameterType === 'parameter' && (
                      <>
                        {/* Collection Type */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Collection Type
                          </label>

                          <div className='col-lg-8'>
                            <Select
                              options={[
                                {value: 'C.LT', label: 'Lasted Value'},
                                {value: 'C.AV', label: 'Average'},
                                {value: 'C.MX', label: 'Maximum Value'},
                                {value: 'C.MN', label: 'Minimum Value'},
                              ]}
                              value={[
                                {value: 'C.LT', label: 'Lasted Value'},
                                {value: 'C.AV', label: 'Average'},
                                {value: 'C.MX', label: 'Maximum Value'},
                                {value: 'C.MN', label: 'Minimum Value'},
                              ].find(
                                (option) =>
                                  option.value === (selectedParameter?.collectionType || 'C.LT')
                              )}
                              onChange={(selectedOption) => {
                                setSelectedParameter({
                                  ...selectedParameter,
                                  collectionType: selectedOption?.value || 'C.LT',
                                })
                              }}
                              classNamePrefix='react-select'
                              isClearable
                            />
                          </div>
                        </div>

                        {/* Operation Type */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Operation Type
                          </label>

                          <div className='col-lg-8'>
                            <Select
                              options={[
                                {value: 'O.N', label: 'None'},
                                {value: 'O.A', label: 'Add'},
                                {value: 'O.S', label: 'Subtract'},
                                {value: 'O.M', label: 'Multiply'},
                                {value: 'O.D', label: 'Divide'},
                              ]}
                              value={[
                                {value: 'O.N', label: 'None'},
                                {value: 'O.A', label: 'Add'},
                                {value: 'O.S', label: 'Subtract'},
                                {value: 'O.M', label: 'Multiply'},
                                {value: 'O.D', label: 'Divide'},
                              ].find(
                                (option) =>
                                  option.value === (selectedParameter?.operationType || 'O.N')
                              )}
                              onChange={(selectedOption) => {
                                setSelectedParameter({
                                  ...selectedParameter,
                                  operationType: selectedOption?.value || 'O.N',
                                })
                              }}
                              classNamePrefix='react-select'
                              isClearable
                            />
                          </div>
                        </div>

                        {/* Operation Value */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Operation Value
                          </label>

                          <div className='col-lg-8'>
                            <input
                              type='number'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Operation Value'
                              value={selectedParameter?.operationValue || 0}
                              onChange={(e) => {
                                setSelectedParameter({
                                  ...selectedParameter,
                                  operationValue: e.target.value,
                                })
                              }}
                            />
                          </div>
                        </div>

                        {/* Parameter name */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Parameter Name
                          </label>

                          <div className='col-lg-8'>
                            <input
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Parameter name'
                              value={parameterName}
                              onChange={(e) => setParameterName(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Parameter Unit */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Parameter Unit
                          </label>
                          <div className='col-lg-8 fv-row'>
                            <Select
                              options={unitOptions}
                              value={unitOptions.find((option) => option.value === parameterUnit)}
                              onChange={(selectedOption) => {
                                setParameterUnit(selectedOption?.value || '')
                              }}
                              classNamePrefix='react-select'
                              isClearable
                              formatOptionLabel={formatOptionLabel}
                            />
                          </div>
                        </div>

                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label fw-bold fs-6'>
                            Parameter Icon
                          </label>
                          <div className='col-lg-8'>
                            {iconUrl ? (
                              <img src={iconUrl} alt='Device Icon' className='w-100px h-100px' />
                            ) : (
                              <p>No Icon Available</p>
                            )}
                          </div>
                        </div>

                        {/* Owner */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Owner
                          </label>

                          <div className='col-lg-8'>
                            <input
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Parameter name'
                              value={parameterOwner}
                              onChange={(e) => setParameterOwner(e.target.value)}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {selectedParameter?.parameterType === 'setting_parameter' && (
                      <>
                        {/* Parameter name */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Setting Parameter Name
                          </label>

                          <div className='col-lg-8'>
                            <input
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Parameter name'
                              value={parameterName}
                              onChange={(e) => setParameterName(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Parameter Unit */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Setting Parameter Unit
                          </label>
                          <div className='col-lg-8 fv-row'>
                            <Select
                              options={unitOptions}
                              value={unitOptions.find((option) => option.value === parameterUnit)}
                              onChange={(selectedOption) => {
                                setParameterUnit(selectedOption?.value || '')
                              }}
                              classNamePrefix='react-select'
                              isClearable
                              formatOptionLabel={formatOptionLabel}
                            />
                          </div>
                        </div>

                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label fw-bold fs-6'>
                            Setting Parameter Icon
                          </label>
                          <div className='col-lg-8'>
                            <img
                              src={
                                deviceData.premium
                                  ? 'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/Setting_parameter%2Fsetting_parameter_premium.png?alt=media&token=2617106e-4985-4347-96e5-523d62c50bad'
                                  : 'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/Setting_parameter%2Fsetting_parameter.png?alt=media&token=7e3655c7-3ef6-4287-8610-8fbf133d41ee'
                              }
                              alt='Device Icon'
                              className='w-100px h-100px'
                            />
                          </div>
                        </div>

                        {/* Owner */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Owner
                          </label>

                          <div className='col-lg-8'>
                            <input
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Parameter name'
                              value={parameterOwner}
                              onChange={(e) => setParameterOwner(e.target.value)}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {selectedParameter?.parameterType === 'status_parameter' && (
                      <>
                        {/* Parameter name */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Status Parameter Name
                          </label>

                          <div className='col-lg-8'>
                            <input
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Parameter name'
                              value={parameterName}
                              onChange={(e) => setParameterName(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Parameter Unit */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Status Parameter Unit
                          </label>
                          <div className='col-lg-8 fv-row'>
                            <Select
                              options={unitOptions}
                              value={unitOptions.find((option) => option.value === parameterUnit)}
                              onChange={(selectedOption) => {
                                setParameterUnit(selectedOption?.value || '')
                              }}
                              classNamePrefix='react-select'
                              isClearable
                              formatOptionLabel={formatOptionLabel}
                            />
                          </div>
                        </div>

                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label fw-bold fs-6'>
                            Status Parameter Icon
                          </label>
                          <div className='col-lg-8'>
                            <img
                              src={
                                'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/status_parameter%2F258682998-765cb53b-7e26-4a95-a1a0-986381559617.png?alt=media&token=b1f45a54-02d2-4a34-8daa-b37363a02e42'
                              }
                              alt='Device Icon'
                              className='w-100px h-100px'
                            />
                          </div>
                        </div>

                        {/* Owner */}
                        <div className='row mb-3'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                            Owner
                          </label>

                          <div className='col-lg-8'>
                            <input
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Parameter name'
                              value={parameterOwner}
                              onChange={(e) => setParameterOwner(e.target.value)}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            {selectedParameter !== null &&
              (selectedParameter?.parameterType === 'parameter' ||
                selectedParameter?.parameterType === 'setting_parameter' ||
                selectedParameter?.parameterType === 'status_parameter') && (
                <button
                  onClick={() => handleCreateParameter()}
                  className='btn btn-primary'
                  disabled={
                    (selectedParameter?.parameterType === 'parameter' ||
                      selectedParameter?.parameterType === 'setting_parameter' ||
                      selectedParameter?.parameterType === 'status_parameter') &&
                    (parameterName === '' || parameterUnit === '')
                  }
                >
                  Create Parameter
                </button>
              )}
          </div>
        </div>
      </div>
    </>
  )
}

export {VBoxCreateNewParameter}
